import React from "react";
import { ShellProps, MenuItemProp } from "../ModuleProps";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, createStyles, Theme, darken } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { authSelector } from "../redux/selectors";
import { experimentalFeatureCheck } from "./experimentalFeatureHelper";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuElement: {
      color: theme.palette.secondary.contrastText,
      "&:hover": {
        backgroundColor: darken("#293445", 0.3),
      },
    },
    menuContainer: {
      width: '100%'
    }
  })
);

const ListItemComponent: React.FC<
  MenuItemProp & { className: string; dataTest: string }
> = ({ pathOrUrl, className, children, module, dataTest }) =>
  module ? (
    <ListItem
      component={Link}
      to={pathOrUrl}
      color="inherit"
      className={className}
      data-test={dataTest}
    >
      {children}
    </ListItem>
  ) : (
    <ListItem
      component="a"
      href={pathOrUrl}
      color="inherit"
      className={className}
      data-test={dataTest}
    >
      {children}
    </ListItem>
  );

type MenuProps = {
  items: ShellProps["items"];
};

export const Menu: React.FC<MenuProps> = ({ items = [] }) => {
  const classes = useStyles();
  const user = useSelector(authSelector);

  return (
    <div className={classes.menuContainer}>
      <List>
        {items
          .filter((item) => item.visibility(user))
          .filter((item) =>
            item.experimentalFeatureVisibleName
              ? experimentalFeatureCheck(
                  user,
                  item.experimentalFeatureVisibleName
                )
              : true
          )
          .filter(
            (item) =>
              !(item.experimentalFeatureHiddenName
                ? experimentalFeatureCheck(
                    user,
                    item.experimentalFeatureHiddenName
                  )
                : false)
          )
          .map((item) => {
            const menuTitle =
              typeof item.menuTitle === "function"
                ? item.menuTitle(user)
                : item.menuTitle;
            return (
              <ListItemComponent
                key={item.pathOrUrl}
                {...item}
                className={classes.menuElement}
                dataTest={`side-nav-links-${menuTitle}`}
              >
                <ListItemIcon>
                  <item.menuIcon className={classes.menuElement} />
                </ListItemIcon>
                <ListItemText primary={menuTitle} />
              </ListItemComponent>
            );
          })}
      </List>
    </div>
  );
};
